module.exports = __webpack_public_path__ + "static/media/7.9b0d93c5.jpg";